module.exports = require('./helpers/bundle-url').getBundleURL('esHYc') + "logo-dark.eefe0b7f.svg";